module.exports = __webpack_public_path__ + "static/img/1.3400c3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/board/components/DownloadData/images/1.png
// module id = ZsYQ
// module chunks = 1